export default [
  {
    id: "GWII-GHC-1.1",
    pow_d: 421,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-1.2",
    pow_d: 428,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-2.1",
    pow_d: 442,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1326576, m2: 9280, size: 142.95 },
    ],
  },
  {
    id: "GWII-GHC-2.2",
    pow_d: 442,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1326576, m2: 9280, size: 142.95 },
    ],
  },
  {
    id: "GWII-GHC-3.1",
    pow_d: 427,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-3.2",
    pow_d: 415,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-4.1",
    pow_d: 384,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-4.2",
    pow_d: 449,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-6.1",
    pow_d: 412,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-6.2",
    pow_d: 431,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-8.1",
    pow_d: 422,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
  {
    id: "GWII-GHC-8.2",
    pow_d: 423,
    pdf: "",
    tour: "",
    sold: false,
    date: '',
    history: [
      { date: "2026.07.27", price: 1190345.6, m2: 9280, size: 128.27 },
    ],
  },
]
